import React, { useEffect, useRef, useState } from 'react';
import Form from 'components/Form/FormComponents/Form';
import TextField from 'components/Form/FormComponents/TextField'
import SelectField from 'components/Form/FormComponents/SelectField';
import Button from 'components/Button/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import {
    SidebarCloseButton,
    SidebarHeader,
    SidebarHeaderWrapper,
    SidebarOverlay,
    SidebarWrapper,
    StyledQuickSelectButton,
    StyledQuickSelectClearButton,
    StyledQuickSelectTitle,
    StyledSidebar
} from './Sidebar.styles';
import CutInfoContainer from './CutInfoContainer';
import Column from "../../../Grid/Column";
import Row from "../../../Grid/Row";
import { useDavidApi } from "../../../../utility/DavidApi/DavidApi";
import styled from 'styled-components';
import { screenWidth } from 'utility/screen-width';
import { cutStepDetails } from "../cutStepDetails";
import FlexWraper from 'components/Grid/FlexWrapper';
import { SURFACE_OPTIONS } from 'utility/productSurfaces';

// Same three surfaces as the cut form. Filters cuts by pricing.product.surface.
const PRODUCT_FILTER_CHOICES = SURFACE_OPTIONS.map(surface => ({
    label: surface,
    value: surface,
}));

function MapSidebar({
    initialState,
    handleFilterSubmit,
    cuts,
    inputs,
    setInputs,
    hide,
    isOpen,
    setLoading,
    refreshCuts,
    setSidebarFilterSubmitted,
 }) {
    const api = useDavidApi();

    const quickSelectClientNames = ['Centerpoint', 'Evansville Water', 'Evansville Sewer'];

    const quickSelectClients = api.clients
        ? api.clients.filter(client => quickSelectClientNames.includes(client.name))
        : [];

    const resetClientFilter = () => {
        const newInputs = {...inputs};
        delete newInputs["project.client"];
        setInputs(newInputs);
        setClientSelectState(!clientSelectState);
    };

    const resetStepFilter = () => {
        const newInputs = {...inputs};
        delete newInputs.step;
        setInputs(newInputs);
        setClientSelectState(!clientSelectState);
    }

    const submitHandler = (e) => {
        e.preventDefault();
        handleFilterSubmit(e);
        scrollToFilteredResults();
        setSidebarFilterSubmitted(true);
    }

    const resetHandler = (e) => {
        e.preventDefault();
        setInputs(initialState);
        scrollToClearedForm();
        handleFilterSubmit(e, true);
        setSidebarFilterSubmitted(false);
    }

    useEffect(() => {
        if (api.clients !== null) {
            return;
        }

        (async () => {
            await api.getClients();
        })();
    }, [api, api.clients]);

    const [clientSelectState, setClientSelectState] = useState(false);

    useEffect(() => {
        handleFilterSubmit();
        setSidebarFilterSubmitted(true);
    }, [clientSelectState]);

    const filteredResults = useRef();

    const scrollToFilteredResults = () => {
        filteredResults.current.scrollIntoView();
    }

    const clearedForm = useRef();

    const scrollToClearedForm = () => {
        clearedForm.current.scrollIntoView();
    }

    return (
        <div>
            <SidebarOverlay />
            <SidebarWrapper>
                <StyledSidebar isOpen={isOpen} >
                    <div ref={clearedForm}></div>
                    <SidebarHeaderWrapper>
                        <SidebarHeader>
                            <h3>Filter Results</h3>
                            <SidebarCloseButton onClick={hide}>
                                <span aria-hidden="true">&times;</span>
                            </SidebarCloseButton>
                        </SidebarHeader>
                    </SidebarHeaderWrapper>
                    <Form values={inputs} setValues={setInputs} onSubmit={submitHandler} style={{marginTop:'40px'}}>
                        <StyledQuickSelectTitle>Client</StyledQuickSelectTitle>
                        <Row gutter={8}>
                            {quickSelectClients.map(client => (
                                <Column width={1/1} key={client.id}>
                                    <StyledQuickSelectButton
                                        type="button"
                                        onClick={() => {
                                            setInputs({...inputs, "project.client": client.id});
                                            setClientSelectState(!clientSelectState);
                                        }}
                                        isSelected={inputs["project.client"] == client.id}
                                    >
                                        <FontAwesomeIcon icon={solid('user')} style={{marginRight: '6px'}} />
                                        {client.name}
                                    </StyledQuickSelectButton>
                                </Column>
                            ))}
                            <Column width={1/1}>
                                <StyledQuickSelectClearButton
                                    type="button"
                                    onClick={resetClientFilter}
                                    isSelected={!inputs["project.client"]}
                                >
                                    <FontAwesomeIcon icon={solid('x')} style={{marginRight: '6px', fontSize: '14px'}} />
                                    Clear Clients
                                </StyledQuickSelectClearButton>
                            </Column>
                        </Row>
                        <StyledQuickSelectTitle style={{ marginTop: '12px' }}>Cut Step</StyledQuickSelectTitle>
                        <Row gutter={8} style={{marginBottom: "8px"}}>
                            {cutStepDetails.map(({ label, value, color }) => (
                                <Column width={1/2} key={value}>
                                    <StyledQuickSelectButton
                                        type="button"
                                        onClick={() => {
                                            setInputs({...inputs, step: label});
                                            setClientSelectState(!clientSelectState);
                                        }}
                                        isSelected={inputs.step === label}
                                    >
                                        <FontAwesomeIcon icon={solid('map-marker-alt')} style={{marginRight: '6px', color: color}} />
                                        {label}
                                    </StyledQuickSelectButton>
                                </Column>
                            ))}
                            <Column width={1/2}>
                                <StyledQuickSelectClearButton
                                    type="button"
                                    onClick={resetStepFilter}
                                    isSelected={!inputs.step}
                                >
                                    <FontAwesomeIcon icon={solid('x')} style={{marginRight: '6px', fontSize: '14px'}} />
                                    Clear Steps
                                </StyledQuickSelectClearButton>
                            </Column>
                        </Row>
                        {/* <FuzzySearchSelect
                            label="Client"
                            name='["project.client"]'
                            placeholder="Select One..."
                            items={api.clients?.map( client => ({
                                label: client.name,
                                value: client.id,
                                id: client.id,
                            }) ) }
                        /> */}
                        <SelectField
                            label="Product"
                            name='["pricing.product.surface"]'
                            placeholder="Select One..."
                            choices={PRODUCT_FILTER_CHOICES}
                        />
                        {/* <SelectField
                            label="Cut Step"
                            name="step"
                            placeholder="Select One..."
                            choices={cutStepDetails}
                        /> */}
                        <TextField
                            label="Project Number"
                            name='["project.projectNumber"]'
                        />
                        <TextField
                            label="Excavation Number"
                            name='["project.excavationNumber"]'
                        />
                        <TextField
                            label="Street Number"
                            name="address"
                        />
                        <TextField
                            label="Street"
                            name="street"
                        />
                        <FlexWraper>
                            <StyledFilterButton
                                onClick={submitHandler}
                                iconLeft={<FontAwesomeIcon icon={solid('check')} />}
                                size="sm"
                            >
                                Filter
                            </StyledFilterButton>
                            <StyledResetButton
                                onClick={(e) => {resetHandler(e)}}
                                iconLeft={<FontAwesomeIcon icon={solid('x')} />}
                                size="sm"
                                variant="red"
                            >
                                Reset
                            </StyledResetButton>
                        </FlexWraper>
                    </Form>
                    <h4 ref={filteredResults} style={{paddingTop: '10px'}}>Cut List</h4>
                    <hr />
                    {cuts && cuts?.length >= 1 && cuts.map(cut => (
                        <CutInfoContainer
                            cut={cut}
                            key={cut.id}
                            refreshCuts={refreshCuts}
                            setLoading={setLoading}
                        />
                    ))}
                    {!cuts?.length &&
                        <p>There are no cuts that match your search.</p>
                    }
                </StyledSidebar>
            </SidebarWrapper>
        </div>
    )
}

export default MapSidebar;

const StyledFilterButton = styled(Button)`
    margin-top: 10px;
    margin-bottom: 20px;

    @media ${screenWidth.below.sm} {
        margin: 0;
        max-width: 100%;
        font-size: 16px;
    }
`;

const StyledResetButton = styled(Button)`
    margin-top: 10px;
    margin-bottom: 20px;

    @media ${screenWidth.below.sm} {
        margin-top: 0;
        margin-bottom: 8px;
        max-width: 100%;
        font-size: 16px;
    }
`;

